import { createStore } from 'owa-satcheljs';
import type {
    CalendarConfigurationStateMap,
    CalendarConfigurationState,
} from './schema/CalendarConfigurationState';

export function defaultCalendarConfigurationState(): CalendarConfigurationState {
    return {
        calendarConfiguration: null,
        txpSettings: null,
        statusCode: 0,
    };
}
const calendarConfigurationStore: () => CalendarConfigurationStateMap =
    createStore<CalendarConfigurationStateMap>('calendarConfiguration', {
        entries: new Map(),
    });

export default calendarConfigurationStore;
